import { Avatar } from '@crehana/compass.ui/v3/avatar';

import { useTranslation } from '../../../i18n';
import type { TRequestResponder } from '../../../types';

type TRespondedByRowProps = {
  responder: TRequestResponder;
};

export const RespondedByRow = ({ responder }: TRespondedByRowProps) => {
  const { t } = useTranslation();

  return (
    <div className="tw-flex tw-flex-col tw-cds-gap-1">
      <span className="tw-cds-font-subtitle-01 tw-cds-text-default">
        {t('REQUEST_DETAIL_RESPONDED_BY_LABEL')}
      </span>
      <div className="tw-flex tw-items-center tw-cds-gap-2">
        <Avatar
          src={responder.profile_picture.url}
          alt={responder.full_name}
          size="sm"
        />
        <span className="tw-cds-font-body-02 tw-cds-text-subtle">
          {responder.full_name}
        </span>
      </div>
    </div>
  );
};
